import React, { useEffect, useState } from "react";
import "./AddBusniess.css";
import Overly from "../../assets/images/overly.png";
import InputFeild from "components/Input/Input";
import Header from "pages/Home1/Header";
import Footer from "components/Footer";
import { MdOutlineAttachment } from "react-icons/md";
import { MdOutlineImage } from "react-icons/md";
import { MdCheckCircle, MdClose } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const AddBusniessDetails = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigation = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};
  const { user } = item || {};
  const token = localStorage.getItem("accessToken");
  const MAX_FILE_SIZE = 2 * 1024 * 1024; 
  
  const [formData, setFormData] = useState({
    // companyName: "",
    location: "",
    vatNumber: "",
    uploadDoc: null,
    uploadImage: null,
    description: "",
    fullName: "",
    position: "" || "",
    email: user?.email || "",
    business_license: "",
    bank_details: {
      bankName: "",
      accountHolderName: "",
      accountNumber: "",
      iban: "",
    },
  });

  const handleBankDetailsChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      bank_details: { ...prev.bank_details, [field]: value },
    }));
  };

  const [uploading, setUploading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    getCurrentLocation();
  }, []);

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          try {
            const response = await axios.get(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyB_nNvYWSCB2haI7DCgR6chQmsg-T4oj8s`
            );
            const locationName = response.data.results[0].formatted_address;
            setFormData((prev) => ({ ...prev, location: locationName || "" }));
          } catch (error) {
            console.error("Error fetching location:", error);
          }
        },
        (error) => console.error("Error getting current location:", error)
      );
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFormData((prev) => ({
      ...prev,
      bank_details: { bankName: "", accountHolderName: "", accountNumber: "", iban: "" },
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > MAX_FILE_SIZE) {
        toast.error("PDF size should be less than 2MB");
        e.target.value = null;
        return;
      }
      setFormData((prev) => ({ ...prev, uploadDoc: selectedFile }));
      e.target.value = null;
    }
  };

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > MAX_FILE_SIZE) {
        toast.error("Image size should be less than 2MB");
        e.target.value = null;
        return;
      }
      setFormData((prev) => ({ ...prev, uploadImage: selectedFile }));
      e.target.value = null;
    }
  };

  const validateForm = () => {
    const newErrors = {};
    // if (!formData.companyName) newErrors.companyName = "Shop Name is required.";
    // if (!formData.location) newErrors.location = "Location is required.";
    if (!formData.vatNumber) newErrors.vatNumber = "TAX Registration Number is required.";
    if (!formData.business_license) newErrors.business_license = "Business License Number is required.";
    if (!formData.bank_details?.iban) newErrors.bank_details = "Bank Details are required.";
    if (!formData.description) newErrors.description = "Description is required.";
    if (!formData.uploadDoc) {
      newErrors.uploadDoc = "Please upload a document.";
    } else if (formData.uploadDoc.size > MAX_FILE_SIZE) {
      newErrors.uploadDoc = "PDF is too large! Max limit is 2MB.";
    }
    if (formData.uploadImage && formData.uploadImage.size > MAX_FILE_SIZE) {
      toast.error("Business image is too large! Max limit is 2MB.");
      return false;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setUploading(true);
      const uploadFormData = new FormData();
      uploadFormData.append("file", formData.uploadDoc);
      
      const uploadResponse = await axios.post(
        "https://backend.washta.com/api/uploadFile",
        uploadFormData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      const documentUrl = uploadResponse.data.data.path;

      let imageUrl = "";
      if (formData.uploadImage) {
        const imageFormData = new FormData();
        imageFormData.append("file", formData.uploadImage);
        const imageResponse = await axios.post(
          "https://backend.washta.com/api/uploadFile",
          imageFormData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        imageUrl = imageResponse.data.data.path;
      }

      const businessDetails = {
        uploadDocument: documentUrl,
        businessImage: imageUrl,
        description: formData.description,
        // companyName: formData.companyName,
        // location: formData.location,
        VATNumber: formData.vatNumber,
        fullName: formData.fullName || "",
        position: formData.position,
        email: formData.email,
        business_license: formData.business_license,
        bank_name: formData.bank_details.bankName,
        account_holder_name: formData.bank_details.accountHolderName,
        account_number: formData.bank_details.accountNumber,
        iban: formData.bank_details.iban,
      };

      await axios.post(
        `https://backend.washta.com/api/seller/Business/${item?.user?.id}`,
        businessDetails,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Successful sign up. Our team will update your request shortly");

      setFormData({
        companyName: "", location: "", vatNumber: "",
        uploadDoc: null, uploadImage: null, description: "",
        fullName: "", position: "", email: user?.email || "",
        bank_details: { bankName: "", accountHolderName: "", accountNumber: "", iban: "" },
      });

      setTimeout(() => navigation("/not-verified"), 2000);

    } catch (error) {
      console.error("Error submitting form:", error);
      if (error.code === "ERR_NETWORK" || (error.response && error.response.status === 413)) {
        toast.error("File size is too large or server connection failed. Please use a smaller file (Max 2MB).");
      } 
      else if (error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } 
      else {
        toast.error("Something went wrong. Please check your internet or file size.");
      }
    } finally {
      setUploading(false);
    }
  };

  const bankIsFilled = formData.bank_details.iban && formData.bank_details.bankName;

  return (
    <>
      <Header btnText="Become a Partner" btnLink={() => navigation("/become-a-partner")} />

      <div className="vbs-page-wrapper">
        <img src={Overly} className="vbs-bg-overlay-img" alt="" />

        <div className="vbs-container">
          <div className="vbs-main-card">
            <div className="vbs-card-header">
              <div className="vbs-status-badge">Partner Onboarding</div>
              <h1 className="vbs-page-title">Add Business Details</h1>
              <p className="vbs-page-desc">Tell us about your business so we can get you verified.</p>
            </div>

            <div className="vbs-step-label">
              <span className="vbs-step-number">01</span> Business Info
            </div>

            <div className="vbs-form-grid">
              {/* <div className="vbs-input-group">
                <InputFeild
                  paddingBottom="5px"
                  type="text"
                  label="Shop Name *"
                  placeholder="e.g. SpeedWash Pro"
                  value={formData.companyName}
                  onChange={(value) => handleChange("companyName", value)}
                />
                {errors.companyName && <p className="vbs-error-msg">{errors.companyName}</p>}
              </div> */}

              {/* <div className="vbs-input-group">
                <InputFeild
                  paddingBottom="5px"
                  type="text"
                  label="Location *"
                  placeholder="Enter Your Location"
                  value={formData.location}
                  onChange={(value) => handleChange("location", value)}
                />
                {errors.location && <p className="vbs-error-msg">{errors.location}</p>}
              </div> */}

              <div className="vbs-input-group">
                <InputFeild
                  paddingBottom="5px"
                  type="text"
                  label="TAX Registration Number *"
                  placeholder="e.g. TRN-XXXXXXXX"
                  value={formData.vatNumber}
                  onChange={(value) => handleChange("vatNumber", value)}
                />
                {errors.vatNumber && <p className="vbs-error-msg">{errors.vatNumber}</p>}
              </div>

              <div className="vbs-input-group">
                <InputFeild
                  paddingBottom="5px"
                  type="text"
                  label="Business License *"
                  placeholder="License Number"
                  value={formData.business_license}
                  onChange={(value) => handleChange("business_license", value)}
                />
                {errors.business_license && <p className="vbs-error-msg">{errors.business_license}</p>}
              </div>

              <div className="vbs-input-group">
                <InputFeild
                  paddingBottom="5px"
                  type="text"
                  label="Position"
                  placeholder="e.g. Owner / Manager"
                  value={formData.position}
                  onChange={(value) => handleChange("position", value)}
                />
              </div>

              <div className="vbs-input-group">
                <span className="vbs-input-label">Bank Details *</span>
                <button
                  type="button"
                  className={`vbs-bank-trigger ${bankIsFilled ? "vbs-bank-success" : ""}`}
                  onClick={() => setIsModalOpen(true)}
                >
                  {bankIsFilled ? (
                    <>
                      <MdCheckCircle className="vbs-icon-check success" />
                      <span>Bank details saved — edit</span>
                    </>
                  ) : (
                    <>
                      <span className="vbs-bank-placeholder">Add bank details</span>
                      <span className="vbs-arrow-icon">→</span>
                    </>
                  )}
                </button>
                {errors.bank_details && <p className="vbs-error-msg">{errors.bank_details}</p>}
              </div>
            </div>

            <div className="vbs-step-label" style={{ marginTop: 32 }}>
              <span className="vbs-step-number">02</span> Documents & Media
            </div>

            <div className="vbs-form-grid">
              <div className="vbs-input-group" style={{minWidth:'100%',maxWidth:'37%'}}>
                <span className="vbs-input-label">Document (PDF) *</span>
                <input type="file" id="fileUpload" accept=".pdf" onChange={handleFileChange} style={{ display: "none" }} />
                <label htmlFor="fileUpload" className={`vbs-dropzone ${formData.uploadDoc ? "vbs-dropzone-filled" : ""}`}>
                  {formData.uploadDoc ? (
                    <div className="vbs-file-preview">
                      <MdOutlineAttachment className="vbs-upload-icon" />
                      <span className="vbs-file-name">{formData.uploadDoc.name}</span>
                      <button
                        type="button"
                        className="vbs-btn-remove"
                        onClick={(e) => { e.preventDefault(); setFormData((p) => ({ ...p, uploadDoc: null })); }}
                      >
                        Remove
                      </button>
                    </div>
                  ) : (
                    <div className="vbs-upload-idle">
                      <MdOutlineAttachment className="vbs-upload-icon-large" />
                      <span className="vbs-upload-text">Click to upload PDF</span>
                    </div>
                  )}
                </label>
                {errors.uploadDoc && <p className="vbs-error-msg">{errors.uploadDoc}</p>}
              </div>

              <div className="vbs-input-group" style={{maxWidth:'37%',minWidth:'100%'}}>
                <span className="vbs-input-label">Business Image</span>
                <input type="file" id="imageUpload" accept="image/*" onChange={handleImageChange} style={{ display: "none" }} />
                <label htmlFor="imageUpload" className={`vbs-dropzone ${formData.uploadImage ? "vbs-dropzone-filled" : ""}`}>
                  {formData.uploadImage ? (
                    <div className="vbs-file-preview">
                      <img
                        src={URL.createObjectURL(formData.uploadImage)}
                        alt="preview"
                        className="vbs-image-thumb"
                      />
                      <span className="vbs-file-name">{formData.uploadImage.name}</span>
                      <button
                        type="button"
                        className="vbs-btn-remove"
                        onClick={(e) => { e.preventDefault(); setFormData((p) => ({ ...p, uploadImage: null })); }}
                      >
                        Remove
                      </button>
                    </div>
                  ) : (
                    <div className="vbs-upload-idle">
                      <MdOutlineImage className="vbs-upload-icon-large" />
                      <span className="vbs-upload-text">Click to upload image</span>
                    </div>
                  )}
                </label>
              </div>
            </div>

            <div className="vbs-input-group" style={{ marginTop: 20 }}>
              <span className="vbs-input-label">Description *</span>
              <div className={`vbs-text-area-wrapper ${errors.description ? "vbs-text-area-invalid" : ""}`}>
                <textarea
                  className="vbs-text-area-field"
                  placeholder="Write a short description about your business, services, and working hours..."
                  value={formData.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                  rows={4}
                />
              </div>
              {errors.description && <p className="vbs-error-msg">{errors.description}</p>}
            </div>

            <button
              onClick={handleFormSubmit}
              className="vbs-btn-submit"
              disabled={uploading}
            >
              {uploading ? (
                <span className="vbs-loader-row">
                  <span className="vbs-loader-spinner" /> Uploading…
                </span>
              ) : (
                "Submit for Verification →"
              )}
            </button>
          </div>
        </div>

        {isModalOpen && (
          <>
            <div className="vbs-modal-overlay" onClick={() => setIsModalOpen(false)} />
            <div className="vbs-modal-content" role="dialog" aria-modal="true">
              <div className="vbs-modal-header">
                <h3 className="vbs-modal-title">Bank Details</h3>
                <button className="vbs-modal-btn-close" onClick={() => setIsModalOpen(false)}>
                  <MdClose />
                </button>
              </div>
              <p className="vbs-modal-subtitle">Your payment info is kept secure and encrypted.</p>

              <div className="vbs-modal-form-grid">
                <div className="vbs-input-group">
                  <InputFeild
                    paddingBottom="5px"
                    type="text"
                    label="Bank Name *"
                    placeholder="e.g. Emirates NBD"
                    value={formData.bank_details.bankName}
                    onChange={(v) => handleBankDetailsChange("bankName", v)}
                  />
                </div>
                <div className="vbs-input-group">
                  <InputFeild
                    paddingBottom="5px"
                    type="text"
                    label="Account Holder Name *"
                    placeholder="Full name on account"
                    value={formData.bank_details.accountHolderName}
                    onChange={(v) => handleBankDetailsChange("accountHolderName", v)}
                  />
                </div>
                <div className="vbs-input-group">
                  <InputFeild
                    paddingBottom="5px"
                    type="number"
                    validatePhone={false}
                    label="Account Number *"
                    placeholder="Account number"
                    value={formData.bank_details.accountNumber}
                    onChange={(v) => handleBankDetailsChange("accountNumber", v)}
                  />
                </div>
                <div className="vbs-input-group">
                  <InputFeild
                    paddingBottom="5px"
                    type="text"
                    label="IBAN *"
                    placeholder="e.g. AE07 0331 2345 6789 0123 456"
                    value={formData.bank_details.iban}
                    onChange={(v) => handleBankDetailsChange("iban", v)}
                  />
                </div>
              </div>

              <div className="vbs-modal-footer">
                <button className="vbs-btn-secondary" onClick={handleCancel}>Cancel</button>
                <button className="vbs-btn-primary" onClick={() => setIsModalOpen(false)}>Save Details</button>
              </div>
            </div>
          </>
        )}
      </div>

      <ToastContainer />
      <Footer />
    </>
  );
};

export default AddBusniessDetails;